import { createFileRoute, redirect } from "@tanstack/react-router";
import { MonthlyConsents } from "@/features/monthly-consents";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/monthly-consents/")({
  beforeLoad: ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["SUBSCRIPTION_VIEW"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <MonthlyConsents />,
});

export { Route };
